const GoogleReviews = () => {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
          Von Kundinnen und Kunden in Leer geschätzt
        </h2>
        <p className="text-foreground-600 text-base md:text-lg mb-10 md:mb-14">
          Ihre Zufriedenheit ist unsere größte Motivation.
        </p>

        {/* Rating Card */}
        <div className="bg-background-100 border border-background-200/70 rounded-xl p-8 md:p-10">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            {/* Left: Rating summary */}
            <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left">
              <div className="flex items-center justify-center gap-2 mb-3">
                {[1, 2, 3, 4].map((i) => (
                  <i
                    key={i}
                    className="ri-star-fill w-7 h-7 flex items-center justify-center text-yellow-400 text-xl"
                  ></i>
                ))}
                <i className="ri-star-half-fill w-7 h-7 flex items-center justify-center text-yellow-400 text-xl"></i>
              </div>

              <p className="font-heading text-3xl md:text-4xl text-foreground-950 mb-1">
                4,6 von 5 Sternen
              </p>
              <p className="text-foreground-600 text-base md:text-lg mb-1">
                Basierend auf{' '}
                <strong className="text-foreground-800">192 Google-Bewertungen</strong>
              </p>
              <p className="text-foreground-500 text-sm">Stand: 13.08.2026</p>
            </div>

            {/* Divider */}
            <div className="hidden lg:block w-px self-stretch bg-background-200/70"></div>

            {/* Right: Highlighted qualities */}
            <div className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left">
              <p className="text-foreground-600 text-sm md:text-base mb-4">
                Besonders geschätzt werden:
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-2 md:gap-3">
                {[
                  'Persönliche Beratung',
                  'Freundlichkeit',
                  'Fachwissen',
                  'Qualität',
                  'Große Auswahl',
                ].map((tag) => (
                  <span
                    key={tag}
                    className="inline-flex items-center px-3 py-1.5 bg-accent-50 text-accent-800 rounded-full text-xs md:text-sm font-medium border border-accent-200"
                  >
                    <i className="ri-check-line w-3 h-3 flex items-center justify-center mr-1"></i>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/70">
            <p className="text-xs text-foreground-400">
              Bewertungen basieren auf öffentlich einsehbaren Kundenmeinungen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;